export var EnvironmentModels;
(function (EnvironmentModels) {
    class EnvironmentCloningStateModel {
        constructor(cloningState) {
            this.cloningState = cloningState;
        }
    }
    EnvironmentModels.EnvironmentCloningStateModel = EnvironmentCloningStateModel;
    class EnvironmentModel {
        constructor(id, name, isProduction) {
            this.id = id;
            this.name = name;
            this.isProduction = isProduction;
        }
    }
    EnvironmentModels.EnvironmentModel = EnvironmentModel;
    class CloneEnvironmentModel {
        constructor(id, managementApiKey, deliveryPreviewApiKey, securedDeliveryApiKey) {
            this.id = id;
            this.managementApiKey = managementApiKey;
            this.deliveryPreviewApiKey = deliveryPreviewApiKey;
            this.securedDeliveryApiKey = securedDeliveryApiKey;
        }
    }
    EnvironmentModels.CloneEnvironmentModel = CloneEnvironmentModel;
})(EnvironmentModels || (EnvironmentModels = {}));
//# sourceMappingURL=environment.models.js.map